// import { Brands } from './sections/Brands';
import { Footer } from './sections/Footer';
import { Header } from './sections/Header';
import { AboutUs } from './sections/AboutUs';
import { OurGoal } from './sections/OurGoal';

const App = () => {
  return (
    <>
      <Header />
      {/* <Brands /> */}
      <OurGoal />
      <AboutUs />
      <Footer />
    </>
  );
};

export default App;
